import { ContractCgrpOnCondition } from '@core/models/contract-cgrp-on-condition.model';
import { Contract } from './contract.model';
import { Target } from './target.model';

export interface JsonContractCgrpOn {
  id?: number;
  idContract?: number;
  targetCode?: string;
  startDate?: any;
  endDate?: any;
  value?: string;
  contractItem?: Contract;
  conditions?: ContractCgrpOnCondition[];
  target?: Target;
}

export class ContractCgrpOn {
  id: number;
  idContract: number;
  targetCode: string;
  startDate: string;
  endDate: string;
  value: string;
  conditions?: ContractCgrpOnCondition[];
  target?: Target;

  constructor(JsonContractCgrpOn: JsonContractCgrpOn = null) {
    this.id = JsonContractCgrpOn.id;
    this.idContract = JsonContractCgrpOn.idContract;
    this.targetCode = JsonContractCgrpOn.targetCode;
    this.startDate = this.getDate(JsonContractCgrpOn.startDate.date);
    this.endDate = this.getDate(JsonContractCgrpOn.endDate.date);

    this.value = JsonContractCgrpOn.value;
    this.conditions = JsonContractCgrpOn.conditions;
    this.target = JsonContractCgrpOn.target;
  }

  getDate(str) {
    str = str.split(' ');
    if (str.length > 0) {
      const dateParts = str[0].split('-');
      if (dateParts.length === 3) {
        return `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
      }
    }

    return '';
  }
}
